<div fxLayout="column" fxLayoutAlign="start center" class="message">
  <p
    [innerHTML]="survey?.hasConfirmation ? (survey.confirmation | safeHtml) : 'Thank you for completing the survey.'"
  ></p>
</div>
